import type { Configuration, IRequest } from '../..';
import { CobliAxios } from '../../request/CobliAxios';
import HttpMethod from '../../request/HttpMethod';

export class PasswordRequester {
  private axiosInstance: CobliAxios;

  constructor(
    configuration: Configuration,
    axiosInstance: CobliAxios = new CobliAxios(configuration)
  ) {
    this.axiosInstance = axiosInstance;
  }

  // Change Password

  public changePassword = (
    userName: string,
    oldPassword: string,
    newPassword: string
  ): Promise<void> => {
    const body = JSON.stringify({
      username: userName,
      old_password: oldPassword,
      new_password: newPassword,
    });

    const requestData: IRequest = {
      endpoint: '/account/password',
      method: HttpMethod.POST,
      body,
    };

    return this.axiosInstance.request(requestData).then(() => {});
  };

  // Password Recovery

  public changePasswordByRecoveryToken = (
    token: string,
    password: string
  ): Promise<void> => {
    const body = JSON.stringify({ token, password });

    const requestData: IRequest = {
      endpoint: '/account/recovery/change-password',
      method: HttpMethod.POST,
      body,
    };

    return this.axiosInstance.request(requestData).then(() => {});
  };

  // Forget password (token request)

  public forgetPassword = (recoveryEmail: string): Promise<boolean> => {
    const email = recoveryEmail.trim().toLocaleLowerCase();
    const requestData: IRequest = {
      endpoint: '/account/recovery/forget-password',
      method: HttpMethod.POST,
      body: JSON.stringify({
        email,
      }),
    };
    return this.axiosInstance.request(requestData).then(() => true);
  };

  // Token validation

  public validateToken = (token: string): Promise<boolean> => {
    const requestData: IRequest = {
      endpoint: '/account/recovery/validate-token',
      method: HttpMethod.POST,
      body: JSON.stringify({
        token,
      }),
    };
    return this.axiosInstance.request(requestData).then(() => true);
  };
}

export default PasswordRequester;
